import React from 'react';
import { INSPECTION_STATUS_OPTIONS } from '../inspectionChecklists';

/**
 * Pass / Fail / N/A selector.
 *
 * Replaces a <select> per checklist row. A technician on a ladder holding a
 * phone should not have to open a dropdown 40 times — three always-visible
 * 44px targets is one tap per item instead of three.
 *
 * The selected state is carried by fill *and* label weight, not colour alone.
 */

const ACTIVE = {
  Pass: 'bg-success text-white border-success',
  Fail: 'bg-danger text-white border-danger',
  'N/A': 'bg-muted-fg text-white border-muted-fg',
};

const InspectionStatusToggle = ({ value, onChange, disabled = false, name }) => (
  <div
    role="radiogroup"
    aria-label={name || 'Inspection status'}
    // `shrink-0` matters: as a flex sibling of a full-width remarks field the
    // group would otherwise be squeezed until "N/A" clipped.
    className="inline-flex w-full overflow-hidden rounded-md border border-border-strong sm:w-auto sm:shrink-0"
  >
    {INSPECTION_STATUS_OPTIONS.map((option, i) => {
      const selected = value === option;
      return (
        <button
          key={option}
          type="button"
          role="radio"
          aria-checked={selected}
          disabled={disabled}
          onClick={() => onChange(selected ? '' : option)}
          className={[
            'min-h-11 flex-1 px-3 text-sm font-medium transition-colors duration-fast sm:min-w-[3.75rem] sm:flex-none',
            'cursor-pointer disabled:cursor-not-allowed disabled:opacity-60',
            i > 0 ? 'border-l border-border-strong' : '',
            selected
              ? `${ACTIVE[option] || ACTIVE['N/A']} font-semibold`
              : 'bg-surface text-muted-fg hover:bg-muted hover:text-foreground',
          ].join(' ')}
        >
          {option}
        </button>
      );
    })}
  </div>
);

export default InspectionStatusToggle;
